import script from "./UpdateProfileView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpdateProfileView.vue?vue&type=script&setup=true&lang=ts"

import "./UpdateProfileView.vue?vue&type=style&index=0&id=11f903c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.16_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11f903c3"]])

export default __exports__